import { v4 as uuidv4 } from "uuid";
import { generateStaticQuestionId } from "../../../../../utils/goalsUtils";

export const leadSelf = {
    "blockId": uuidv4(),
    "description": "<p>This section focuses on the following competencies: <strong>Vision and Goal Setting, Responsibility, Resilience, Feedback, and Inclusion</strong>. Share how often you have experienced the leader demonstrating the below behaviors. Identify <strong>at least one behavior</strong> that the leader does not demonstrate often or always, as these highlight potential opportunities for growth.</p>",
    "selfDescription": "<p>This section focuses on the following competencies: <strong>Vision and Goal Setting, Responsibility, Resilience, Feedback, and Inclusion</strong>. Share how often you demonstrate the below behaviors. Identify <strong>at least one behavior</strong> you don't demonstrate often or always, as these highlight potential opportunities for growth.</p>",
    "goalId": "dynamic360Strength",
    isRequired: true,
    feedbackBasedCondition: [
        {
            answeringCondition: [
                {
                    columnValues: ["1", "2"],
                    numberOfAnswersNeeded: 3,
                },
                {
                    columnValues: ["3", "4"],
                    numberOfAnswersNeeded: 3,
                },
                {
                    columnValues: ["5", "6"],
                    numberOfAnswersNeeded: 3,
                }
            ]
        }

    ],
    allowNAOption: true,
    "questions": [
        {
            "question": "",
            "options": [
                {
                    "label": "Never",
                    "value": "1"
                },
                {
                    "label": "Rarely",
                    "value": "2"
                },
                {
                    "label": "Occasionally",
                    "value": "3"
                },
                {
                    "label": "Sometimes",
                    "value": "4"
                },
                {
                    "label": "Often",
                    "value": "5"
                },
                {
                    "label": "Always",
                    "value": "6"
                },
                { "label": "Can't answer", "value": "0" }
            ],
            "questionDimension": "Custom Matrix",
            "type": "matrix",
            "qid": uuidv4(),
            "matrixQuestions": [
                {
                    "subCategoryId": generateStaticQuestionId("Vision & Goal Setting"),
                    "subCategory": "Vision & Goal Setting",
                    "staticQuestionId": generateStaticQuestionId("Demonstrates the Arc'teryx culture and values through their actions and decisions"),
                    "HTMLText": "<p>Demonstrates the Arc'teryx culture and values through their actions and decisions</p>",
                    "isSelected": true,
                    "text": "Demonstrates the Arc'teryx culture and values through their actions and decisions",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Vision & Goal Setting"),
                    "subCategory": "Vision & Goal Setting",
                    "staticQuestionId": generateStaticQuestionId("Sets clear goals and objectives that align with the Arc'teryx strategy"),
                    "HTMLText": "<p>Sets clear goals and objectives that align with the Arc'teryx strategy</p>",
                    "isSelected": true,
                    "text": "Sets clear goals and objectives that align with the Arc'teryx strategy",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Vision & Goal Setting"),
                    "subCategory": "Vision & Goal Setting",
                    "staticQuestionId": generateStaticQuestionId("Articulates their vision and how it supports the organization's long-term goals"),
                    "HTMLText": "<p>Articulates their vision and how it supports the organization's long-term goals</p>",
                    "isSelected": true,
                    "text": "Articulates their vision and how it supports the organization's long-term goals",
                    "value": uuidv4()
                },

                {
                    "subCategoryId": generateStaticQuestionId("Responsibility"),
                    "subCategory": "Responsibility",
                    "staticQuestionId": generateStaticQuestionId("Demonstrates personal accountability"),
                    "HTMLText": "<p>Demonstrates personal accountability</p>",
                    "isSelected": true,
                    "text": "Demonstrates personal accountability",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Responsibility"),
                    "subCategory": "Responsibility",
                    "staticQuestionId": generateStaticQuestionId("Holds others accountable for their commitments"),
                    "HTMLText": "<p>Holds others accountable for their commitments</p>",
                    "isSelected": true,
                    "text": "Holds others accountable for their commitments",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Responsibility"),
                    "subCategory": "Responsibility",
                    "staticQuestionId": generateStaticQuestionId("Demonstrates an awareness of how their actions impact their teams and partners"),
                    "HTMLText": "<p>Demonstrates an awareness of how their actions impact their teams and partners</p>",
                    "isSelected": true,
                    "text": "Demonstrates an awareness of how their actions impact their teams and partners",
                    "value": uuidv4()
                },


                {
                    "subCategoryId": generateStaticQuestionId("Resilience"),
                    "subCategory": "Resilience",
                    "staticQuestionId": generateStaticQuestionId("Responds constructively to mistakes and adversity"),
                    "HTMLText": "<p>Responds constructively to mistakes and adversity</p>",
                    "isSelected": true,
                    "text": "Responds constructively to mistakes and adversity",
                    "value": uuidv4()
                },

                {
                    "subCategoryId": generateStaticQuestionId("Resilience"),
                    "subCategory": "Resilience",
                    "staticQuestionId": generateStaticQuestionId("Encourages others to overcome obstacles and embrace challenges"),
                    "HTMLText": "<p>Encourages others to overcome obstacles and embrace challenges</p>",
                    "isSelected": true,
                    "text": "Encourages others to overcome obstacles and embrace challenges",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Resilience"),
                    "subCategory": "Resilience",
                    "staticQuestionId": generateStaticQuestionId("Utilizes rewards and recognition to celebrate collective success "),
                    "HTMLText": "<p>Utilizes rewards and recognition to celebrate collective success </p>",
                    "isSelected": true,
                    "text": "Utilizes rewards and recognition to celebrate collective success ",
                    "value": uuidv4()
                },

                {
                    "subCategoryId": generateStaticQuestionId("Feedback"),
                    "subCategory": "Feedback",
                    "staticQuestionId": generateStaticQuestionId("Supports a culture where everyone consistently seeks and provides feedback"),
                    "HTMLText": "<p>Supports a culture where everyone consistently seeks and provides feedback</p>",
                    "isSelected": true,
                    "text": "Supports a culture where everyone consistently seeks and provides feedback",
                    "value": uuidv4()
                },

                {
                    "subCategoryId": generateStaticQuestionId("Feedback"),
                    "subCategory": "Feedback",
                    "staticQuestionId": generateStaticQuestionId("Listens and responds appropriately to feedback"),
                    "HTMLText": "<p>Listens and responds appropriately to feedback</p>",
                    "isSelected": true,
                    "text": "Listens and responds appropriately to feedback",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Feedback"),
                    "subCategory": "Feedback",
                    "staticQuestionId": generateStaticQuestionId("Provides actionable insights to others"),
                    "HTMLText": "<p>Provides actionable insights to others</p>",
                    "isSelected": true,
                    "text": "Provides actionable insights to others",
                    "value": uuidv4()
                },

                {
                    "subCategoryId": generateStaticQuestionId("Inclusion"),
                    "subCategory": "Inclusion",
                    "staticQuestionId": generateStaticQuestionId("Treats everyone fairly and with respect"),
                    "HTMLText": "<p>Treats everyone fairly and with respect</p>",
                    "isSelected": true,
                    "text": "Treats everyone fairly and with respect",
                    "value": uuidv4()
                },

                {
                    "subCategoryId": generateStaticQuestionId("Inclusion"),
                    "subCategory": "Inclusion",
                    "staticQuestionId": generateStaticQuestionId("Creates a sense of safety and belonging"),
                    "HTMLText": "<p>Creates a sense of safety and belonging</p>",
                    "isSelected": true,
                    "text": "Creates a sense of safety and belonging",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Inclusion"),
                    "subCategory": "Inclusion",
                    "staticQuestionId": generateStaticQuestionId("Encourages diverse perspectives and approaches"),
                    "HTMLText": "<p>Encourages diverse perspectives and approaches</p>",
                    "isSelected": true,
                    "text": "Encourages diverse perspectives and approaches",
                    "value": uuidv4()
                },


            ],
            "questionLabel": "Custom Matrix"
        }
    ],
    "isSelected": true,
    "type": "matrix",
    "dimension": "LEAD SELF"
}